import React, { Component } from 'react';
import {connect} from 'react-redux';
import {  emptyDemoSecSubQuestionResponse, getSecSubQuesDataById, updateSecSubQuestion, getSecSubQuesOptionsById, softDeleteSecSubOption} from '../../actions/demographics';
import EditSecSubQuestion from '../../components/demographics/editSecSubQuestion';

class EditDemographicsSecSubQuestion extends Component {
  constructor(props){
    super(props)

    this.queryString = window.location.href;

    if (this.queryString !== "") {
        this.sec_sub_ques_id = this.queryString.split("&ssq:")[1];  
    }

    this.state={
        editCategoryPageData : "",
        sec_sub_ques_id : this.sec_sub_ques_id
    };

    this.emptyDemoSecSubQuestionResponse = this.emptyDemoSecSubQuestionResponse.bind(this);
    this.updateSecSubQuestion = this.updateSecSubQuestion.bind(this);
    this.softDeleteSecSubOption = this.softDeleteSecSubOption.bind(this);
    this.gotoSecondSubquestionView = this.gotoSecondSubquestionView.bind(this);
  }

 

  componentDidMount(){
    if(this.state.sec_sub_ques_id){
       this.props.dispatch(getSecSubQuesDataById(this.state.sec_sub_ques_id));
       this.props.dispatch(getSecSubQuesOptionsById(this.state.sec_sub_ques_id));
    }
  }

  emptyDemoSecSubQuestionResponse(){
      this.props.dispatch(emptyDemoSecSubQuestionResponse());
  }

  updateSecSubQuestion(data){
  this.props.dispatch(updateSecSubQuestion(data));
  }

  softDeleteSecSubOption(data){
    this.props.dispatch(softDeleteSecSubOption(data));
  }

  gotoSecondSubquestionView(catId, quesId, subQuesId){
  //  this.props.history.push('/demoSecSubQuestion/&c:'+ catId+'/&q:'+quesId+'/&sq:'+subQuesId);
  }
  
  render(){
   
    let showEditDemographicsCategoriesSubQuestionView ="";
    if(this.props.showDemoGraphicsEditSecSubQuestion){
         showEditDemographicsCategoriesSubQuestionView = <EditSecSubQuestion
        demoGraphicsEditSecSubQuestionSuccess = {this.props.demoGraphicsEditSecSubQuestionSuccess}
        demoGraphicsEditSecSubQuestionData = {this.props.demoGraphicsEditSecSubQuestionData}
        updateSecSubQuestion = {this.updateSecSubQuestion}

        secSubQuestionUpdateSuccess = {this.props.secSubQuestionUpdateSuccess}
        secSubQuestionUpdateSuccessMessage = {this.props.secSubQuestionUpdateSuccessMessage}
        secSubQuestionUpdateFailMessage = {this.props.secSubQuestionUpdateFailMessage}

        emptyDemoSecSubQuestionResponse = {this.emptyDemoSecSubQuestionResponse}

        demoGraphicsCatSecSubQuesOptionsListSuccess = {this.props.demoGraphicsCatSecSubQuesOptionsListSuccess}
        demoGraphicsCatSecSubQuesOptionsListData = {this.props.demoGraphicsCatSecSubQuesOptionsListData}

        softDeleteSecSubOption = {this.softDeleteSecSubOption}

        gotoSecondSubquestionView = {this.gotoSecondSubquestionView}
    />
    }
    
      
    return (
        <div> 
             {showEditDemographicsCategoriesSubQuestionView}
        </div>
    );
  }
}

const  mapStateToProps =(state) =>{
  return {
    showDemoGraphicsEditSecSubQuestion    : state.demographics.showDemoGraphicsEditSecSubQuestion,
    demoGraphicsEditSecSubQuestionSuccess : state.demographics.demoGraphicsEditSecSubQuestionSuccess,
    demoGraphicsEditSecSubQuestionData    : state.demographics.demoGraphicsEditSecSubQuestionData,
   
    secSubQuestionUpdateSuccess : state.demographics.secSubQuestionUpdateSuccess,
    secSubQuestionUpdateSuccessMessage : state.demographics.secSubQuestionUpdateSuccessMessage,
    secSubQuestionUpdateFailMessage : state.demographics.secSubQuestionUpdateFailMessage,

    demoGraphicsCatSecSubQuesOptionsListSuccess : state.demographics.demoGraphicsCatSecSubQuesOptionsListSuccess,
    demoGraphicsCatSecSubQuesOptionsListData : state.demographics.demoGraphicsCatSecSubQuesOptionsListData,
  }
}

export default connect(mapStateToProps)(EditDemographicsSecSubQuestion);



// WEBPACK FOOTER //
// ./src/pages/demographics/editDemoSecSubQuestion.js